import { IXetTotNghiepRequest } from "../../../model/request/xet-tot-nghiep/IXetTotNghiepRequest";
import { IXetTotNghiepPhamViSinhVienViewModel } from "../../../model/response/xet-tot-nghiep/IXetTotNghiepPhamViSinhVienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eXetTotNghiepActionsObj = {
    XET_START: {} as IXetTotNghiepRequest,
    XET_SUCCESS: "",
    XET_ERROR: "",

    XET_KET_QUA_HOC_TAP_START: {} as IXetTotNghiepRequest,
    XET_KET_QUA_HOC_TAP_SUCCESS: "",
    XET_KET_QUA_HOC_TAP_ERROR: "",

    XET_CHUNG_CHI_START: {} as IXetTotNghiepRequest,
    XET_CHUNG_CHI_SUCCESS: "",
    XET_CHUNG_CHI_ERROR: "",

    LOAD_DANH_SACH_XET_START: 0,
    LOAD_DANH_SACH_XET_SUCCESS: {} as IXetTotNghiepPhamViSinhVienViewModel[],
    LOAD_DANH_SACH_XET_ERROR: "",

    CLOSE_PROCESSING_MODAL: undefined,

    SHOW_THAM_SO_MODAL: undefined,
    CLOSE_THAM_SO_MODAL: undefined,

    SHOW_CAU_HINH_SO_CAO_SO_MODAL: undefined,
    CLOSE_CAU_HINH_SO_CAO_SO_MODAL: undefined,

    SHOW_CAU_HINH_SO_HIEU_MODAL: undefined,
    CLOSE_CAU_HINH_SO_HIEU_MODAL: undefined,

    SHOW_CAU_HINH_SO_QUYET_DINH_MODAL: undefined,
    CLOSE_CAU_HINH_SO_QUYET_DINH_MODAL: undefined,

    SHOW_CAU_HINH_SO_IN_QUYET_DINH_MODAL: undefined,
    CLOSE_CAU_HINH_SO_IN_QUYET_DINH_MODAL: undefined,

    SINH_VIEN_DU_DIEU_KIEN_CHANGE_SELECTED_IDS:  {} as number[],

    SINH_VIEN_KHONG_DU_DIEU_KIEN_CHANGE_SELECTED_IDS:  {} as number[],

    CHANGE_NAM_HOC: {} as string,
    CHANGE_ID_DOT_XET: {} as number,
    CHANGE_ID_HE: {} as number,
    CHANGE_ID_KHOA: {} as number,
    CHANGE_KHOA_HOC: {} as number,
    CHANGE_ID_CHUYEN_NGANH: {} as number,
    CHANGE_ID_LOP: {} as number,
    CHANGE_ID_KHOI_NGANH: {} as number,
    CHANGE_FOCUSED_TAB: {} as "dot-xet" | "pham-vi-sinh-vien" | "xet-tot-nghiep" | "xet-ket-qua-hoc-tap" | "xet-chung-chi",
    CHANGE_VISIBLE_COMBBOX_DOT_XET_TOT_NGHIEP: {} as boolean,
    CHANGE_IS_HIEN_THI_THE_THONG_KE: {} as boolean,
    CHANGE_IS_HIEN_THI_BO_LOC_LOP_XET: {} as boolean,
}

export const eXetTotNghiepActionIds = generateActionTypeIds(eXetTotNghiepActionsObj, "XET_TOT_NGHIEP");
export type IXetTotNghiepActionTypes = IGenericActionType<typeof eXetTotNghiepActionsObj, "XET_TOT_NGHIEP">;